var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05786 21.4919L10.0174 15.5323C10.4702 15.0796 11.0842 14.8252 11.7245 14.8252C12.3648 14.8252 12.9789 15.0796 13.4316 15.5323L18.7245 20.8252M18.7245 20.8252L20.7245 22.8252M18.7245 20.8252L21.3508 18.1989C21.8035 17.7463 22.4176 17.4919 23.0579 17.4919C23.6981 17.4919 24.3123 17.7463 24.7649 18.1989L28.0579 21.4919",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0578 3.49121C10.4181 3.49121 7.59831 3.49121 5.72813 5.0885C5.46255 5.31532 5.21522 5.56265 4.98841 5.82822C3.39111 7.69841 3.39111 10.5182 3.39111 16.1579C3.39111 21.7975 3.39111 24.6173 4.98841 26.4875C5.21522 26.7531 5.46255 27.0004 5.72813 27.2272C7.59831 28.8245 10.4181 28.8245 16.0578 28.8245C21.6974 28.8245 24.5172 28.8245 26.3874 27.2272C26.653 27.0004 26.9003 26.7531 27.1271 26.4875C28.7244 24.6173 28.7244 21.7975 28.7244 16.1579",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7246 7.49121C21.511 6.68209 23.6042 3.49121 24.7246 3.49121C25.845 3.49121 27.9382 6.68209 28.7246 7.49121M24.7246 4.15788V12.8245",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d69494ede0d901a502a357239da40c3a.svg";
export { ForwardRef as ReactComponent };